import React from "react";

const Titles = () => (
  <div>
    <h1 className="title-container__title">Weather App</h1>
    <h3 className="title-container__subtitle">
      Find out temperature, conditions and more...
    </h3>
  </div>
);

export default Titles;
